import React, { useEffect, useState } from "react";
import "../../assets/styles/local/AddMissingItems.css";
import { IoIosClose } from "react-icons/io";
import CheckboxIcon from "../../assets/images/CheckboxWhite.svg";
import CheckboxBlueIcon from "../../assets/images/CheckboxBlue.svg";
import { useDispatch, useSelector } from "react-redux";
import { ProductDropdown } from "../../redux/actions/action";
import { Image } from "react-bootstrap";
import plusBorderWhite from "../../assets/icons/Plus-border-white.svg";
import Package from "../../assets/icons/package.svg";
import DelIcon from "../../assets/icons/DeleteIconCircle.svg";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { SyncOutlined } from "@ant-design/icons";

const AddItems = ({ setOpenAddItem, openAddItem, addMissingItems }) => {
  const dispatch = useDispatch();

  const fetchProductDropdownData = useSelector(
    (state) => state.user.fetchProductDropdown,
  );

  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      setIsBuildingBlock(
        getAppSideNavOptions.some(
          (x) => x.packageId === process.env.REACT_APP_IS_PREMIUM,
        ),
      );
    }
  }, [getAppSideNavOptions]);

  const [showLoader, setShowLoader] = useState(true);
  const [searchItems, setSearchItems] = useState("");
  const [stockData, setStockData] = useState([]);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  useEffect(() => {
    fetchScreenTranslations("Stock Levels").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  useEffect(() => {
    dispatch(ProductDropdown());
  }, []);

  useEffect(() => {
    if (fetchProductDropdownData != null && fetchProductDropdownData?.status) {
      setStockData(fetchProductDropdownData?.data);
      setShowLoader(false);
    }
  }, [fetchProductDropdownData]);

  const handleCheckboxChange = (productPartid) => {
    const updatedData = stockData.map((item) =>
      item.productPartid === productPartid
        ? { ...item, isChecked: !item.isChecked }
        : item,
    );
    setStockData(updatedData);
  };

  const handleSearchInputChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchItems(e.target.value);

    clearTimeout(window.searchTimeout);

    window.searchTimeout = setTimeout(() => {
      if (!value.trim()) {
        setStockData(fetchProductDropdownData?.data || []);
        return;
      }

      const result = fetchProductDropdownData?.data?.filter(
        (item) =>
          item.productPartName.toLowerCase().includes(value.toLowerCase()) ||
          item.productPartCode.toLowerCase().includes(value.toLowerCase()) ||
          item.itemdescription.toLowerCase().includes(value.toLowerCase()) ||
          // supplier name and item id searching
          item.supplier?.some(
            (supplier) =>
              supplier.productpartcode
                ?.toLowerCase()
                .includes(value.toLowerCase()) ||
              supplier.suppliername
                ?.toLowerCase()
                .includes(value.toLowerCase()) ||
              supplier.itemid?.toLowerCase().includes(value.toLowerCase()),
          ),
      );
      setStockData(result);
    }, 300);
  };

  const AddMissingItems = () => {
    const orderProductsData = stockData?.filter((val) => val.isChecked);
    addMissingItems(orderProductsData);
    setOpenAddItem(!openAddItem);
  };

  return (
    <div className="add-item-wrappers">
      <div className="d-flex justify-content-between align-items-center bgdiv">
        <p className="inputparts px-3">Parts</p>
        <div className="add-item-title w-100">
          <input
            className="update-member-input-noborder add-member-input bgforinput w-100"
            value={searchItems}
            onChange={handleSearchInputChange}
            // placeholder="Search ... "
            placeholder={t("Search")}
          />
        </div>
        <img
          src={DelIcon}
          alt=""
          className="mx-3 cursor-pointer"
          onClick={() => setOpenAddItem(!openAddItem)}
        />
      </div>
      <div className="border-line d-none"></div>
      <div className="stock-items-main gap-0 p-3">
        {showLoader && (
          <p className="text-center">
            please wait while we fetching your data... &nbsp;{" "}
            <SyncOutlined spin />
          </p>
        )}

        {stockData.map((item, index) => (
          <div key={index} className="missing-items add-item-title">
            <img
              onClick={() => handleCheckboxChange(item.productPartid)}
              className="plus-img"
              src={item.isChecked ? CheckboxBlueIcon : CheckboxIcon}
              alt="check-item"
            />

            <div className="count-title">{item.productPartName}</div>
            {isBuildingBlock && (
              <div className="title-hover">
                <div className="items-desc-column1">
                  <div className="desc-image-wrp1 desc-image1 ">
                    {item.cover ? (
                      <>
                        <div
                          className={`product-list-image-default1 ${
                            item.image.length === 0 ? "hover-hide1" : ""
                          }`}
                        >
                          <img
                            src={item.cover}
                            alt=""
                            className="cover-image1"
                          />
                          {item.image && item.image.length > 0 && (
                            <div className="image-row1">
                              {item.image.slice(0, 3).map((val, index) => (
                                <img
                                  key={index}
                                  src={val.image}
                                  alt={`Images ${index + 1}`}
                                />
                              ))}
                            </div>
                          )}
                        </div>
                        {item.image && item.image.length > 0 && (
                          <span className="desc-image-plus1">
                            <Image
                              height={10}
                              width={10}
                              src={plusBorderWhite}
                            />
                          </span>
                        )}
                      </>
                    ) : (
                      <div className="product-list-default1">
                        <img src={Package} alt="" className="default-img1" />
                        <div className="product-image-title d-none">
                          Picture
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            <div className="count-col">
              <div>
                {/* Stock  */}
                {t("Stock")}
              </div>
            </div>

            <div className="stock-level-count-items">
              <div className="stock-color">
                <div className="d-flex align-items-center gap-4 justify-content-center">
                  {item.instock > 0 ? (
                    <>
                      <div className="d-flex flex-column align-items-center justify-content-center gap-1">
                        <div
                          style={{
                            backgroundColor: `${item.color}`,
                          }}
                          className="color-code"
                        ></div>
                      </div>

                      <div className="info-items">{item.instock}</div>
                    </>
                  ) : (
                    <div className="empty-item">-</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="add-button-wrp">
        <button
          type="button"
          className="btn add-button add-btn-disable"
          onClick={AddMissingItems}
          disabled={!stockData.some((val) => val.isChecked === true)}
        >
          {/* Add */}
          {t("Add")}
        </button>
      </div>
    </div>
  );
};

export default AddItems;
